import type { ScrapingFrequency } from "../types/keyword";

export const DEFAULT_SCRAPING_FREQUENCY: ScrapingFrequency = "DAILY";
